import axios from 'axios'
import { Toast } from 'vant'
import store from '@/store'
import router from '@/router'
import eventBus from '@/eventbus'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
})

const handleSuccess = response => {
  if (response.status !== 200) {
    Toast({
      message: '网络错误，请稍后重试'
    })
  } else if (response.data.code !== 0) {
    if (response.data.code == 401 || response.data.code == 4001) {
      eventBus.$emit('haddleLogin')
    } else {
      Toast({
        duration: 3000,
        message: response.data.msg
      })
    }
  }
}

axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token') || ''
    config.headers.common['Authorization'] = token
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  response => {
    handleSuccess(response)
    return response
  },
  error => {
    Toast({
      message: '网络错误，请稍后重试'
    })
    return Promise.reject(error)
  }
)

export default axiosInstance
